"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = __importDefault(require("lodash"));
var ajax_1 = require("rxjs/ajax");
var Routes = __importStar(require("./routes"));
var ApiUtils = __importStar(require("./api"));
/**
 * Rocket frontend class
 */
var RocketFrontend = /** @class */ (function () {
    function RocketFrontend(key, secret, prefixUrl, timeout, userPost) {
        if (timeout === void 0) { timeout = 45000; }
        if (userPost === void 0) { userPost = false; }
        /**
         * Timeout of a request
         */
        this._timeout = 45000;
        /**
         * Use POST method for PUT and DEL
         */
        this._usePostForPutAndDel = false;
        this._key = key;
        this._secret = secret;
        this._prefix = prefixUrl;
        this._timeout = timeout;
        this._usePostForPutAndDel = userPost;
    }
    Object.defineProperty(RocketFrontend.prototype, "key", {
        /**
         * API key
         * @return The API key
         */
        get: function () {
            return this._key;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RocketFrontend.prototype, "secret", {
        /**
         * API secret
         * @return The API secret
         */
        get: function () {
            return this._secret;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RocketFrontend.prototype, "prefix", {
        /**
         * API prefix URL
         * @return The API prefix URL
         */
        get: function () {
            return this._prefix;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RocketFrontend.prototype, "timeout", {
        /**
         * Get timeout
         * @return The timeout
         */
        get: function () {
            return this._timeout;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Generate the route and the method
     * @param entity The entity (or an action name)
     * @param method The initial method (post, put, delete, ...)
     * @param id The id to retrieve (can also be a collection of pipers)
     * @return The definitive URL and method
     */
    RocketFrontend.prototype.generateRouteAndMethod = function (entity, method, id) {
        switch (method) {
            case 'post': {
                var url = Routes.create(this._prefix, entity);
                return [url, 'post'];
            }
            case 'file':
            case 'get': {
                if (id === null ||
                    !(typeof id === 'string' || typeof id === 'number')) {
                    throw Error('id cannot be null');
                }
                var url = Routes.get(this._prefix, entity, id);
                return [url, 'get'];
            }
            case 'put': {
                if (id === null ||
                    !(typeof id === 'string' || typeof id === 'number')) {
                    throw Error('id cannot be null');
                }
                var url = Routes.update(this._prefix, entity, id, this._usePostForPutAndDel);
                return [url, this._usePostForPutAndDel ? 'post' : 'put'];
            }
            case 'del':
            case 'delete': {
                if (id === null ||
                    !(typeof id === 'string' || typeof id === 'number')) {
                    throw Error('id cannot be null');
                }
                var url = Routes.del(this._prefix, entity, id, this._usePostForPutAndDel);
                return [url, this._usePostForPutAndDel ? 'get' : 'delete'];
            }
            case 'posts': {
                var url = Routes.createMany(this._prefix, entity);
                return [url, 'post'];
            }
            case 'gets': {
                var url = Routes.getMany(this._prefix, entity);
                return [url, 'post'];
            }
            case 'validation': {
                if (id === null || !(id instanceof Array)) {
                    throw Error('id cannot be null and should be an array');
                }
                var url = Routes.validation(this._prefix, entity, id);
                return [url, 'post'];
            }
            case 'validations': {
                if (id === null || !(id instanceof Array)) {
                    throw Error('id cannot be null and should be an array');
                }
                var url = Routes.validationMany(this._prefix, entity, id);
                return [url, 'post'];
            }
            case 'action': {
                var url = Routes.action(this._prefix, entity);
                return [url, 'post'];
            }
            case 'action-get': {
                var url = Routes.action(this._prefix, entity);
                return [url, 'get'];
            }
            default:
                throw Error('Unknown method');
        }
    };
    /**
     * Generate a RxJS request
     */
    RocketFrontend.prototype.request = function (entity, method, id, body, extraHeaders) {
        if (body === void 0) { body = {}; }
        if (extraHeaders === void 0) { extraHeaders = {}; }
        var _a = this.generateRouteAndMethod(entity, method, id), url = _a[0], finalMethod = _a[1];
        var settings = ApiUtils.getAPISettings(this._key, this._secret, finalMethod, url, body, method === 'file' ? 'blob' : 'json', this._timeout);
        if (method === 'file') {
            settings.headers['Content-Type'] = 'application/octet-stream';
        }
        settings.headers = lodash_1.default.merge({}, settings.headers, extraHeaders);
        return ajax_1.ajax(settings);
    };
    /**
     * Unpack an AjaxResponse from Rxjs and handle errors
     * @param request The ajax response
     */
    RocketFrontend.prototype.unpackResponse = function (request) {
        var response = request.response;
        if (!response) {
            return { success: false, validationErrors: {} };
        }
        var validationErrors = this.unpackValidationErrors(request);
        var _a = response.success, success = _a === void 0 ? false : _a;
        return { success: success, validationErrors: validationErrors, response: response };
    };
    /**
     * Unpack an AjaxResponse from Rxjs to validation errors (if existing)
     * @param request The ajax response
     * @return The validation errors
     */
    RocketFrontend.prototype.unpackValidationErrors = function (request) {
        var response = request.response;
        if (!response) {
            return {};
        }
        var _a = response.validationErrors, valErrors = _a === void 0 ? [] : _a;
        var validationErrors = valErrors.reduce(function (obj, value) {
            var field = value.field, message = value.message;
            if (field in obj) {
                obj[field].push(message);
            }
            else {
                obj[field] = [message];
            }
            return obj;
        }, {});
        return validationErrors;
    };
    /**
     * Unpack an AjaxError from Rxjs and handle errors
     * @param error The ajax error
     */
    RocketFrontend.prototype.unpackError = function (error) {
        var response = error.response, status = error.status;
        var statusStr = "" + status;
        if (statusStr[0] === '4') {
            if (status === 404) {
                return { error: 'NotFoundError', code: 'not_found_error' };
            }
            return { error: response.error, code: response.code };
        }
        if (status === 0) {
            return { error: error, code: 'timeout_error' };
        }
        if (!status) {
            return { error: error, code: 'unknown_error' };
        }
        return { error: response.error, code: 'unknown_error' };
    };
    return RocketFrontend;
}());
exports.default = RocketFrontend;
//# sourceMappingURL=rocket.js.map